export default data => ReactNativeWebView.postMessage(JSON.stringify(data))